<script>
import env from '../env';
export default {
  props:{src:String,lazySrc:String},
  data(){
    return {
      validImage: false,
    }
  },
  computed:{
    lazyImg(){
      if(this.src) return this.src
      if(!this.lazySrc) return this.src
      var pathFile = this.lazySrc.split(env.baseUrl)[1]
      if(pathFile.split("/img/")[1]){
        var x = pathFile.split("/"); x.splice(0,3); pathFile = "/"+x.join("/")
      }
      return env.baseUrl+"/img/10"+pathFile
    }
  },
  mounted(){
    this.lazyInit()
  },
  methods:{
    lazyInit(){
      if(!this.lazySrc) return;
      if(!/\.(jpg|jpeg|png|gif)$/g.test(this.lazySrc)) return;
      var img = new Image;
      img.onload = ()=>{
        this.validImage = true
      }
      img.onerror = ()=>{
        this.validImage = false
      }
      img.src = this.lazySrc
    }
  },
  watch:{
    lazySrc(){ this.lazyInit() }
  }
}
</script>

<template>
  <img :src="validImage?lazySrc:lazyImg"/>
</template>
